import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import get from 'lodash/get';

import PaymentsPromoCodeRedeemForm from './PaymentsPromoCodeRedeemForm';
import PaymentsPromoCodeDeactivateForm from './PaymentsPromoCodeDeactivateForm';
import styles from './style.scss';


class PaymentsPromoCode extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = queryString.parse(props.location.search);
    const invitePromocode = get(queryParams, 'invite', null);

    this.state = {
      isExpanded: true,
      invitePromocode,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { payments: newPayments } = nextProps;
    const { payments } = this.props;
    // automatically expand promocode form
    if (newPayments.redeemCode.code && !payments.redeemCode.code) {
      this.toggleExpanded(true);
    }
  }

  toggleExpanded(value) {
    this.setState((prevState) => {
      const newValue = value === undefined ? !prevState.isExpanded : value;
      return { isExpanded: newValue };
    });
  }

  render() {
    const { isExpanded, invitePromocode } = this.state;
    const { campaign } = this.props.payments.redeemCode;
    return (
      <div className="billetContainer">
        <div
          className={classNames(styles.redeemCodeTitle, 'jest-payments-promocode-title')}
          onClick={() => this.toggleExpanded()}>
          <div className="title-3">У меня есть код на скидку</div>
          <div className={classNames(styles.redeemCodeArrow, { isExpanded })} />
        </div>
        {isExpanded && (
          campaign
            ? (
              <PaymentsPromoCodeDeactivateForm />
            )
            : (
              <PaymentsPromoCodeRedeemForm invitePromocode={invitePromocode} />
            )
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    payments: state.payments,
  };
}

export default withRouter(connect(mapStateToProps, null)(PaymentsPromoCode));
